module.exports = __webpack_public_path__ + "static/media/googlemapspin.ca960139.png";